new Vue({
  el: '.designGalleryV4',
  delimiters: ["[[","]]"],
  mixins: [global],
  data() {
    return {
      designsPerPage: 40,
      mobileFiltersActive: false,
      mobileTypeFilters: false,
      mobileColorFilters: false,
      multiColorFilter: false,
      colorChoices: colorChoices,
      mobileCategoryFilters: false,
      allDesignTypes: false,
      showFilters: false,
      categoryTypeFilter: null,
      startLogin: false,
      subscribeLogin: true,
      userEmail: null,

      totalDesigns: 0,
      totalPages: 0,

      loadMoreIndex: 1,
      allLoaded: false,
      moreLoading: false,

      selectedRec: null,
      squareFeetRecGood: 0,
      squareFeetRecBetter: 0,
      squareFeetRecBest: 0,
      openFilters: [],
    }
  },

  async mounted() {
    this.getUser();

    let elementY;
    window.onscroll = function(e) {
      if(document.querySelector('.designGalleryFilters .filterBodyWrapper')) {
        let element = document.querySelector('.designGalleryFilters .filterBodyWrapper');
        if(!elementY) elementY = window.scrollY + element.getBoundingClientRect().top;

        let designGalleryItems = document.querySelector('.designGalleryItems');
        let designGalleryBottom = designGalleryItems.getBoundingClientRect().bottom;
        
        if(window.scrollY > elementY + 10 && designGalleryBottom > 800) {
          // let clone = elem.cloneNode(true);
          element.classList.add('stickyCheckoutBox');
        } else {
          element.classList.remove('stickyCheckoutBox');
        }
      }
    }

    this.grabbingDesigns = true;
    await this.grabVariations();

    if(this.getParameter('selectedRec')) {
      this.selectedRec = this.getParameter('selectedRec');
      this.squareFeetRecGood = this.getParameter('goodRec');
      this.squareFeetRecBetter = this.getParameter('betterRec');
      this.squareFeetRecBest = this.getParameter('bestRec');
    }

    if (getParameter('page')) {
      this.storage.designsPage = getParameter('page') - 1
    }
    else {
      this.storage.designsPage = 0
    }
    if(landingCategory) {
      this.clearFilters();
      this.storage.designTypeFilters.push(landingCategory);
      this.setSortPosition(landingCategory);
      this.renderFilters = false;
      this.$nextTick(() => {this.renderFilters = true;})
    }
    if(getParameter('design_type')) {
      this.clearFilters();
      if (getParameter('design_type') !== 'none') {
        this.storage.designTypeFilters.push(getParameter('design_type'));
        this.setSortPosition(getParameter('design_type'));
        this.displayFilter('Design Type');
      }

      this.renderFilters = false;
      this.$nextTick(() => {this.renderFilters = true;})
    }
    if(getParameter('category')) {
      this.clearFilters();
      this.storage.roomTypeFilter.push(getParameter('category'));
      this.setSortPosition(getParameter('category'));
      if(this.getParameter('category').includes('Under')) {
        this.displayFilter('Price');
      } else {
        this.displayFilter('Spaces');
      }

      this.renderFilters = false;
      this.$nextTick(() => {
        this.renderFilters = true;
      })
    }
    if(getParameter('color')) {
      this.clearFilters();
      this.storage.colorFilter.push(getParameter('color'));
      this.setSortPosition(getParameter('color'));

      this.renderFilters = false;
      this.$nextTick(() => {
        this.renderFilters = true;
      })
    }
    if(getParameter('clear_filters')) {
      this.clearFilters();
    }
    this.grabFilteredDesigns();
    this.grabCategories();
  },

  computed: {
    totalDesigns() {
      return 10;
    },
    totalDesignPages() {
      let pages = [];
      let totalPages = this.totalPages;

      for(let i = 0; i < totalPages; i++) {
        pages.push(i);
      }

      return pages;
    },

    filteredDesigns() {
      // (ui.designs | filter: feltRightDesigns()).slice(storage.designsPage * designsPerPage, storage.designsPage * designsPerPage + designsPerPage)

      //  = (ui.designs | filter: designFilters())

      let designs = this.designs.filter((design) => {
        let showDesign = true;

        if(!this.designFiltersActive()) {
          if(!design.categories.includes('Felt Right Design')) {
            showDesign = false;
          }
        }

        if(this.designFiltersActive()) {
          let hasDesignType = true;
          if(this.storage.designTypeFilters.length) {
            hasDesignType = false;

            for(let filter of this.storage.designTypeFilters) {
              if(design.categories.includes(filter)) {
                hasDesignType = true;
              }
            }
          }

          let hasColor = true;
          if(this.storage.colorFilter.length) {
            hasColor = false;
            for(let filter of this.storage.colorFilter) {
              if(design.categories.includes(filter)) {
                hasColor = true;
              }
            }
          }

          let hasRoomType = true;
          if(this.storage.roomTypeFilter.length) {
            hasRoomType = true;
            for(let filter of this.storage.roomTypeFilter) {
              if(!design.categories.includes(filter)) {
                hasRoomType = false;
              }
            }
          }

          let hasCategory = true;
          if(this.storage.categoryFilter.length) {
            hasCategory = false;
            for(let filter of this.storage.categoryFilter) {
              if(design.categories.includes(filter)) {
                hasCategory = true;
              }
            }
          }

          if(!hasDesignType || !hasColor || !hasRoomType || !hasCategory) {
            showDesign = false;
          }
        }

        return showDesign;
      })

      function setSortPosition(category, designs) {
        for(let design of designs) {
          if(typeof design.category_position[category] != 'undefined') {
            design.sorted_position = parseInt(design.category_position[category]);
          } else {
            design.sorted_position = design.position + 10000;
          }
        }

        designs = alasql(`SELECT * FROM ? ORDER BY sorted_position`, [designs]);

        return designs;
      }

      if(this.storage.designTypeFilters.length == 1) {
        designs = setSortPosition(this.storage.designTypeFilters[0], designs);
      }
      if(this.storage.colorFilter.length == 1) {
        designs = setSortPosition(this.storage.colorFilter[0], designs);
      }
      if(this.storage.roomTypeFilter.length == 1) {
        designs = setSortPosition(this.storage.roomTypeFilter[0], designs);
      }
      if(this.storage.categoryFilter.length == 1) {
        designs = setSortPosition(this.storage.categoryFilter[0], designs);
      }

      if(!this.designFiltersActive()) {
        designs = setSortPosition('Felt Right Design', designs);
      }

      return designs;
    },
  },

  methods: {

    inWishlist(design) {
      if(!this.user) return false;
      
      return this.user.wishlist.includes(design.id);
    },

    selectedColor(design) {
      let selectedVariation = null;
      let selectedColor = null;
      for(let variation of design.variations) {
        if(variation.design_id == design.id) {
          selectedVariation = variation;
          break;
        }
      }

      if(selectedVariation) {
        for(let choice of design.choices) {
          if(selectedVariation.conditions && selectedVariation.conditions.Color == choice.name) {
            selectedColor = choice;
            break;
          }
        }
      }

      return selectedColor;
    },

    selectColor(color, design) {
      let selectedVariation = null;
      for(let variation of design.variations) {
        if(variation.conditions && (variation.conditions.Color == color.name || variation.conditions.Colors == color.name)) {
          selectedVariation = variation;
          break;
        }
      }

      if(selectedVariation) {
        axios.post('https://studio.feltright.com/load-design', {id: selectedVariation.design_id})
        .then(response => {
          console.log(response.data, 'design found');
          for(let i in this.designs) {
            if(this.designs[i].id == design.id) {
              this.designs[i] = response.data;
              break;
            }
          }
          this.$forceUpdate();
        });
      }

      console.log(selectedVariation, 'selected variation found');
    },

    displayFilter(filter) {
      if(!this.openFilters.includes(filter)) {
        this.openFilters.push(filter);
      } else {
        this.openFilters.splice(this.openFilters.indexOf(filter), 1);
      }
    },
    pageReload(page) {
      window.location.href = `/pages/design-gallery?page=${page + 1}`
    },
    spacesOfficeReload(page) {
      window.location.href = `/pages/spaces-office?page=${page + 1}`
    },
    spacesKidsReload(page) {
      window.location.href = `/pages/spaces-kidsclassroom?page=${page + 1}`
    },

    refreshDesigns() {
      this.storage.designsPage = 0;
      this.loadMoreIndex = 1;

      if(this.storage.colorFilter.length != 1 && !this.multiColorFilter) {
        this.storage.colorFilter.splice(0, 1);
        this.$forceUpdate();
      }

      this.grabFilteredDesigns();
    },

    async grabFilteredDesigns() {
      this.grabbingDesigns = true;

      let initialLoad = false;
      if(!this.designFiltersActive()) {
        initialLoad = true;
      }

      let path = 'https://studio.feltright.com/grab-filtered-designs';

      // let ip = await axios.get('https://api.ipify.org?format=json');
      // ip = ip.data.ip;
      // if(ip == '38.70.255.250') {
      //   path = 'http://localhost:9000/grab-filtered-designs';
      // }

      let areaTarget;
      console.log(this.selectedRec, 'selectedRec');
      if(this.selectedRec) {
        if(this.selectedRec == 'good') {
          areaTarget = this.getParameter('goodRec');
        }
        if(this.selectedRec == 'better') {
          areaTarget = this.getParameter('betterRec');
        }
        if(this.selectedRec == 'best') {
          areaTarget = this.getParameter('bestRec');
        }
      }
      console.log(areaTarget);

      console.log(this.storage.colorFilter, 'color filters');

      axios.post(path, {designTypeFilters: this.storage.designTypeFilters, colorFilter: this.storage.colorFilter, roomTypeFilter: this.storage.roomTypeFilter, categoryFilter: this.storage.categoryFilter, initialLoad: initialLoad, page: this.storage.designsPage + 1, areaTarget})
      .then(response => {
        this.designs = response.data.designs;
        this.totalDesigns = response.data.totalDesigns;
        this.totalPages = response.data.totalPages;
        this.grabbingDesigns = false;
      })
    },

    loadMoreDesigns() {
      let path = 'https://studio.feltright.com/grab-filtered-designs';
      // let path = 'http://localhost:9000/grab-filtered-designs';

      this.moreLoading = true;
      this.loadMoreIndex += 1;

      axios.post(path, {designTypeFilters: this.storage.designTypeFilters, colorFilter: this.storage.colorFilter, roomTypeFilter: this.storage.roomTypeFilter, categoryFilter: this.storage.categoryFilter, initialLoad: false, page: this.loadMoreIndex})
      .then(response => {
        if(response.data && response.data.designs) {
          this.designs = this.designs.concat(response.data.designs);
        }
        this.moreLoading = false;
        this.$forceUpdate();
        console.log(this.moreLoading, 'loading more?')
        if(response.data && response.data.designs && !response.data.designs.length) {
          this.allLoaded = true;
        }
        console.log(this.allLoaded, 'all loaded');
      })
    },

    addFilter(list, category) {
      this.renderFilters = false;
      if(!list.includes(category)) {
        list.push(category);
      } else {
        list.splice(list.indexOf(category), 1);
      }
      this.loadMoreIndex = 1;
      this.$forceUpdate();

      this.grabFilteredDesigns();

      this.$nextTick(() => {
        this.renderFilters = true;
      })
    },

    updateFilters() {
      this.renderFilters = false;
      this.$nextTick(() => {this.renderFilters = true;})
    },

    showAllDesignTypes() {
      this.allDesignTypes = !this.allDesignTypes;

      if(this.allDesignTypes) {
        if(!storage.designTypeFilters.includes('Customer')) {
          storage.designTypeFilters.push('Customer')
        }
        if(!storage.designTypeFilters.includes('Felt Right Design')) {
          storage.designTypeFilters.push('Felt Right Design')
        }
      }

      if(!this.allDesignTypes) {
        storage.designTypeFilters = [];
      }
      this.updateFilters();
    },

    checkColorFilter() {
      setTimeout(() => {
        if(this.storage.colorFilter.length == 1) {
          this.setSortPosition(this.storage.colorFilter[0]);
        }

        if(this.storage.colorFilter.length != 1 && !this.multiColorFilter) {
          this.storage.colorFilter.splice(0, 1);
          this.$forceUpdate();
        }
      }, 10)
    },
    categoryNameMapper(name) {
      if(name == 'Felt Right Design') {
        name = 'Felt Right Designs';
      }

      return name;
    },
    designFiltersActive() {
        let active = false;

        if(this.storage.designTypeFilters.length) {
          active = true;
        }

        if(this.storage.colorFilter.length) {
          active = true;
        }

        if(this.storage.roomTypeFilter.length) {
          for (let item of this.storage.roomTypeFilter) {
            if (!getUrl().includes('spaces-') || ['Office', 'Living Spaces', 'Family / Kitchen Organization', 'Podcast / Recording Studio', 'Headboard', 'Kids / Classroom'].includes(item) === false) active = true
          }
        }

        if(this.storage.categoryFilter.length) {
          active = true;
        }

        if(this.allDesignTypes) {
          active = true;
        }

        return active;
    }
  }
});